import { AppConfig } from "./types";

const config: AppConfig = {
  BASE_API_URL: "https://api.nealthy.xyz",
  BASE_URL: "https://admin.nealthy.xyz",
};
export default config;
